// extracted by mini-css-extract-plugin
export default {"productEditBtn":"manualSelection_productEditBtn__cS65i"};